"use strict";
// Layout of persistent state
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetSpot_Underflow = void 0;
exports.asPlayerPath = asPlayerPath;
exports.asBetSpotPath = asBetSpotPath;
exports.asGamePath = asGamePath;
exports.asRoundPath = asRoundPath;
exports.asRequestToJoin = asRequestToJoin;
exports.makeBetSpotPath = makeBetSpotPath;
exports.makeRoundPath = makeRoundPath;
function asPlayerPath(s) {
    return s;
}
function asBetSpotPath(s) {
    return s;
}
function asGamePath(s) {
    return s;
}
function asRoundPath(s) {
    return s;
}
function asRequestToJoin(s) {
    return s;
}
exports.BetSpot_Underflow = asBetSpotPath('betSpot-underflow');
function zeroPad(i, width) {
    if (width > 6) {
        throw new Error(`Cannot zero pad to ${width} (max 6).  Given: ${i}`);
    }
    const strI = `${i}`;
    if (strI.length >= width) {
        return strI;
    }
    return `0000000${i}`.slice(-width);
}
// Also "underflow" is a valid path (and maybe "lowHalf" and "highHalf", etc)
function makeBetSpotPath(i) {
    return asBetSpotPath(`betSpot${zeroPad(i, 4)}`);
}
function makeRoundPath(id) {
    return `roundId${zeroPad(id, 3)}`;
}
//# sourceMappingURL=Persistent.js.map